import IgromatGameContainer from './container/IgromatGameContainer';

export default IgromatGameContainer;
